import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getQueuesResources,
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
	getQueueViewConfigResource,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskPracticeViewsConfigRoute } from '@jira/router-routes__servicedesk-queues-routes/src/servicedeskPracticeViewsConfigRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { serviceDeskQueuesConfigPageEntryPoint } from './ui/queues-config-page-entry-point/index.tsx';
import {
	ServicedeskQueuesViewsConfig,
	LazyServicedeskQueuesViewsConfig,
} from './ui/views-config/index.tsx';

export const servicedeskPracticeViewsConfigRouteEntry: Route = createEntry(
	servicedeskPracticeViewsConfigRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
		},
		resources: [
			...getQueuesResources(),
			getConsolidationStateResource(),
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			...getQueueViewConfigResource(),
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
		],
		forPaint: [LazyAtlassianNavigation, LazyServicedeskQueuesViewsConfig],
		ufoName: 'service-management.views.config',
		// eslint-disable-next-line no-restricted-syntax
		component: ServicedeskQueuesViewsConfig,
		pageId: ({ query }) => `spa-apps/servicedesk/queues/views-config/${query.config}`,
		entryPoint() {
			return serviceDeskQueuesConfigPageEntryPoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
